import { ByLocales, Locales } from '@monoimin/sb-types';

export const enAndRuLocales: Array<Locales> = ['en', 'ru'];

const enableAllLocales = process.env['NEXT_PUBLIC_PROJECT_SLUG'] === 'monoimin';
export const locales: Array<Locales> = enableAllLocales
  ? ['en', 'ru', 'de', 'tr']
  : ['en', 'ru'];

export const localesMap: ByLocales<true> = locales.reduce(
  (acc, locale) => ({
    ...acc,
    [locale]: true,
  }),
  {} as ByLocales<true>
);

export const localesToString = locales.reduce(
  (acc, locale) => ({ ...acc, [locale]: '' }),
  {}
) as ByLocales<string>;

export const localesList: ReadonlyArray<{ title: string; locale: Locales }> =
  enableAllLocales
    ? [
        { title: 'English', locale: 'en' },
        { title: 'Русский', locale: 'ru' },
        { title: 'Deutsch', locale: 'de' },
        { title: 'Türkçe', locale: 'tr' },
      ]
    : [
        { title: 'English', locale: 'en' },
        { title: 'Русский', locale: 'ru' },
      ];

export const langTitleDict: ByLocales<string> = localesList.reduce<
  ByLocales<string>
>(
  (acc, { title, locale }) => ({
    ...acc,
    [locale]: title,
  }),
  {} as ByLocales<string>
);

export const localesWithRegion = {
  ru: 'ru_RU',
  en: 'en_US',
  de: 'de_DE',
  tr: 'tr_TR',
};

export const defaultNonIntlFolders = {
  en: {},
  ru: {},
  de: {},
  tr: {},
};
